import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-litmus-link',
    templateUrl: './litmus-link.component.html',
    styleUrls: ['./litmus-link.component.scss'],
    standalone: false
})
export class LitmusLinkComponent implements OnInit,OnChanges {
  @Input() links:any=[]
  constructor(){}
  ngOnInit(): void {
    
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.links = (typeof this.links == 'string')?JSON.parse(this.links):this.links;
  }
}
